export const readAssetFromExtension = async (path: string, basePath?: string) => {
  // @todo remove from utils, we shouldn't have any browser specific code here
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const url = basePath ? `${basePath}${path}` : chrome.runtime.getURL(path);
  const file = await fetch(url)
    .then(async (res) => res.text())
    .catch(() => null);
  return file;
};
